import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function DesignCard({ design, className = "" }) {
  return (
    <Link
      to={`/design/${design.id}`}
      className={`design-card rounded-lg overflow-hidden group block ${className}`}
      data-testid={`design-card-${design.id}`}
    >
      {/* Image */}
      <div className="relative aspect-square image-zoom bg-zinc-100">
        <img
          src={design.image_url}
          alt={design.title}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        
        {/* AI Badge */}
        {design.is_ai_generated && (
          <div className="absolute top-3 left-3 badge-ai flex items-center gap-1">
            <Sparkles className="w-3 h-3" />
            AI
          </div>
        )}
      </div>

      {/* Info */}
      <div className="p-4">
        <h3 className="font-medium text-zinc-900 group-hover:text-indigo-600 transition-colors line-clamp-1">
          {design.title}
        </h3>
        <p className="text-sm text-zinc-500 mt-1 line-clamp-1">
          {design.category}
        </p>
        <p className="price-tag mt-2 text-zinc-900">
          ${design.price.toFixed(2)}
        </p>
      </div>
    </Link>
  );
}
